import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    fileId,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.delFile, {
        fileId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
